import { TextBlock } from '../../../Atoms/Text';

export const NotIncludedYet = () => (
  <TextBlock
    size="lg"
    weight="semibold"
    color="amber">
    Not included yet
  </TextBlock>
);
